import { render, staticRenderFns } from "./DaySlots.vue?vue&type=template&id=2c84a6f4&"
import script from "./DaySlots.vue?vue&type=script&charset=utf-8&lang=js&"
export * from "./DaySlots.vue?vue&type=script&charset=utf-8&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports